export default [
  {
    text: 'eposJobs.table.articleName',
    value: 'articleName',
  },
  {
    text: 'eposJobs.table.errorId',
    value: '_id',
  },
  {
    text: 'eposJobs.table.itemId',
    value: 'itemId',
  },
  { text: '', value: 'data-table-expand' },
];
